import Vue from "vue";

Vue.component("chart-column", {
	props: ["loading", "yAxisTitle", "chartTitle", "chartTitleAlignment", "chartData", "chartExporting", "hasLegend"],
	data() {
		return {
			hasData: true,
			footer: ""
		};
	},
	computed: {
		chartOptions: function () {
			const self = this;
			return {
				styledMode: true,
				chart: {
					zoomType: "x", plotBackgroundColor: null, plotBorderWidth: null, plotShadow: false, type: "column"
				},
				title: { text: self.chartTitle, align: self.chartTitleAlignment },
				xAxis: { type: "category" },
				yAxis: { allowDecimals: false, min: 0, title: { text: self.yAxisTitle } },
				plotOptions: { column: { stacking: "normal" } },
				exporting: self.chartExporting,
				borderWidth: 0,
				legend: { enabled: self.hasLegend, reversed: true },
				series: self.chartData
			}
		}
	},
	template: `
		<div>
		    <wto-chart :loading="loading"
		                   :has-data="hasData"
		                   :chart-options="chartOptions"
		                   :footer="footer"></wto-chart>
		</div>
	`
});